import { render, staticRenderFns } from "./ProductionChart.vue?vue&type=template&id=2834479c&lang=pug&"
import script from "./ProductionChart.vue?vue&type=script&lang=js&"
export * from "./ProductionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports